"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMessageContext = exports.MessageProvider = void 0;
var react_1 = __importStar(require("react"));
var useAdminMessage_1 = require("../hook/useAdminMessage");
var MessageContext = (0, react_1.createContext)(undefined);
var MessageProvider = function (_a) {
    var children = _a.children;
    var _b = (0, useAdminMessage_1.useMessageAdmin)(), showSuccess = _b.showSuccess, showError = _b.showError, contextHolder = _b.contextHolder;
    var value = (0, react_1.useMemo)(function () { return ({
        showSuccess: showSuccess,
        showError: showError,
    }); }, [showSuccess, showError]);
    return (react_1.default.createElement(MessageContext.Provider, { value: value },
        contextHolder,
        children));
};
exports.MessageProvider = MessageProvider;
var useMessageContext = function () {
    var context = (0, react_1.useContext)(MessageContext);
    if (!context) {
        throw new Error('useMessageContext must be used within MessageProvider');
    }
    return context;
};
exports.useMessageContext = useMessageContext;
